import { FAVORITES_PROCESSING_END } from 'root/src/client/logic/project/actionIds'

export default () => ({
	type: FAVORITES_PROCESSING_END,
})
